const PREFETCH_MARKER = "data-cb-unity-prefetch";

const BUILDER_ARTIFACTS = [
  "builder.data.unityweb",
  "builder.wasm.code.unityweb",
  "builder.wasm.framework.unityweb",
];

const NON_UNITY_SUBCATEGORIES = new Set(["tape", "part", "tissue", "crinkle", "lbl", "dhc"]);

export function subcategoryUsesUnity(subcategoryCode: string | null | undefined): boolean {
  if (!subcategoryCode) return true;
  return !NON_UNITY_SUBCATEGORIES.has(subcategoryCode.toLowerCase());
}

export function prefetchUnityBuilder(builderUrl: string, subcategoryCode?: string | null): void {
  if (typeof document === "undefined" || !builderUrl) return;
  if (!subcategoryUsesUnity(subcategoryCode)) return;
  if (document.head.querySelector(`link[${PREFETCH_MARKER}]`)) return;

  for (const file of BUILDER_ARTIFACTS) {
    const link = document.createElement("link");
    link.rel = "prefetch";
    link.as = "fetch";
    link.crossOrigin = "anonymous";
    link.href = `${builderUrl}/${file}`;
    link.setAttribute(PREFETCH_MARKER, "");
    document.head.appendChild(link);
  }
}
